export const TEXT = 'text';

export const PHONE = 'phone';

export const EMAIL = 'email';

export const MONEY = 'money';

export const DATE = 'date';

export const INTEGER = 'integer';

export const FLOAT = 'float';

export const DOCUMENT = 'document';

export const PERCENTAGE = 'percentage';

export const PERCENTAGE_DECIMAL = 'percentage-decimal';

export const FIRST_LETTER = 'first-letter';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/input.types.ts